module.exports = __webpack_public_path__ + "static/media/21ECLAC31.77578c8a.jpg";